import React from 'react';
import { Select } from '@paretogroup/tess';
import { SelectOption } from '@shared/select/select.types';
import { FILTER_DRAWER_OPERATIONS_TEXTS } from '../../filter-drawer-operations.constants';

type ValueSelector = {
    isDisabled: boolean,
    onChange: (newValue: SelectOption) => void,
    value: SelectOption,
    options: Array<SelectOption>,
}

export const ValueSelector = ({
    isDisabled,
    value,
    options,
    onChange,
}:ValueSelector) => (
    <Select
        label={FILTER_DRAWER_OPERATIONS_TEXTS.VALUE}
        isDisabled={isDisabled}
        onChange={onChange}
        value={value}
        options={options}
    />
);
